import initialObject from "./group-10-copy-3.svg";
import result from "./group-10-copy-5.svg";
import timeDistanceToObject from "./group-10-copy-6.svg";

export const images = {
  initialObject,
  timeDistanceToObject,
  result,
};
